import PropTypes from "prop-types";
import { DirectionalIcon } from "../DirectionalIcon/DirectionalIcon";
import Camera from "~/content/icons/camera.svg?react";

export function CameraIcon({ className }) {
  return (
    <DirectionalIcon>
      <Camera className={className} />
    </DirectionalIcon>
  );
}

CameraIcon.propTypes = {
  className: PropTypes.string,
};
